import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import { registerQuery, registerSubscription } from '@adornis/baseql/metadata/register.js';
import type { BaseQLSelectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import type { Observable } from 'rxjs';
import { getLivekitAccessTokenResolver, subscribeActiveLivekitRoomsResolver } from '../server/livekit.js';

@Entity()
export class LivekitRoom extends AdornisEntity {
  static override _class = 'LivekitRoom';
  @Field(type => String)
  name!: string;
  @Field(type => [String], { default: v => v ?? [] })
  participants!: string[];
}

export const getLivekitAccessToken: (roomID: string, invisible?: boolean) => () => Promise<string> = registerQuery({
  operationName: 'getLivekitAccessToken',
  resolve: (roomID: string, invisible?: boolean) => () => getLivekitAccessTokenResolver(roomID, invisible),
  type: () => String,
  params: [
    { type: () => String, name: 'roomID' },
    { type: () => Boolean, name: 'invisible' },
  ],
});

export const subscribeActiveLivekitRooms: () => (
  gqlFields: BaseQLSelectionSet<LivekitRoom>,
) => Observable<LivekitRoom[]> = registerSubscription({
  operationName: 'subscribeActiveLivekitRooms',
  type: () => [LivekitRoom],
  resolve: () => (gqlFields: BaseQLSelectionSet<LivekitRoom>) => subscribeActiveLivekitRoomsResolver(),
});
